import { typographyStyles } from "@newsela/angelou";

const { textMObj } = typographyStyles;

export const bannerCss = {
  "&&": {
    margin: "24px 0",
    width: "100%",
  },
};

export const bannerBody = {
  ...textMObj,
};

export const bannerCtaCss = {
  margin: "16px 0",
  div: {
    display: "flex",
  },
};

export const bannerCloseButtonCss = {
  alignSelf: "start",
};
